export const SET_ACTIVE_FACILITY = "SET_ACTIVE_FACILITY";
